/* eslint-disable no-restricted-globals */
import { HTTP_CODE, ERROR_HANDLING_EXPERIENCE } from '../../utils/redirector-utils';

export function isNotFound({ data, itemId }) {
  if (data && !data.product) {
    return {
      shouldRedirect: false,
      isErrorStatus: true,
      httpCode: HTTP_CODE.NOT_FOUND,
      description: `Item ${itemId} not found`,
      errorHandlingExperience: ERROR_HANDLING_EXPERIENCE.PRODUCT
    };
  }

  return null;
}

export function isInvalidItemId({ itemId }) {
  if (!/^\d{8,10}$/.test(itemId)) {
    return {
      shouldRedirect: false,
      isErrorStatus: true,
      httpCode: HTTP_CODE.NOT_FOUND,
      description: `Invalid item id ${itemId}`,
      errorHandlingExperience: ERROR_HANDLING_EXPERIENCE.PRODUCT,
    };
  }

  return null;
}

export const isInvalidQuestionsCanonical = ({ data, path }) => {
  const { canonicalUrl } = data?.product?.identifiers || {};

  if (canonicalUrl) {
    const segments = path?.replace(/^\/|\/$/g, '').split('/');
    const pageNumber = segments?.length > 4 ? segments[segments.length - 1] : 1;
    const page = pageNumber && !isNaN(pageNumber) ? `/${pageNumber}` : '/1';

    const canonicalUrlWithContext = canonicalUrl?.replace('/p/', '/p/questions/').concat(page);

    if (path !== canonicalUrlWithContext && path !== encodeURI(canonicalUrlWithContext)) {
      return {
        shouldRedirect: true,
        httpCode: HTTP_CODE.PERM_REDIRECT,
        redirectPath: canonicalUrlWithContext,
        description: 'redirected for canonical'
      };
    }
  }

  return null;
};

export function isInvalidPageNumber({ data, pageNumber, pageSize = 8 }) {
  const pageNum = Number(pageNumber);

  if (isNaN(pageNum) || pageNum < 1) {
    return {
      shouldRedirect: false,
      isErrorStatus: true,
      httpCode: HTTP_CODE.NOT_FOUND,
      description: `${pageNumber} is not a valid page number`,
      errorHandlingExperience: ERROR_HANDLING_EXPERIENCE.PRODUCT
    };
  }

  if (!data || !data.questionsAnswers) {
    return null;
  }

  const totalResults = data.questionsAnswers.TotalResults || 0;
  const offset = data.questionsAnswers.Offset || 0;
  const maxPage = Math.ceil(totalResults / pageSize);

  const isInvalidPage = (totalResults > 0 && offset >= totalResults)
    || (totalResults > 0 && pageNum > maxPage)
    || (pageNum > 1 && totalResults === 0);

  if (isInvalidPage) {
    return {
      shouldRedirect: false,
      isErrorStatus: true,
      httpCode: HTTP_CODE.NOT_FOUND,
      description: `Page ${pageNum} not found`,
      errorHandlingExperience: ERROR_HANDLING_EXPERIENCE.PRODUCT
    };
  }

  return null;
}